import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"id":"consultant-select","item-text":"nome","item-name":"usuarioId","item-value":"usuarioId","items":_vm.users,"label":!this.isAT || this.$store.state.uf === 'MA'
      ? this.consultorValue || 'Responsável'
      : this.isAT
      ? 'ATS'
      : 'Consultor',"placeholder":_vm.consultorLabel,"multiple":_vm.isMultiple,"clearable":""},model:{value:(_vm.filter.usuarioId),callback:function ($$v) {_vm.$set(_vm.filter, "usuarioId", $$v)},expression:"filter.usuarioId"}},[_c('template',{slot:"no-data"},[_vm._v(" Nenhum usuário retornado ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }